export default __webpack_public_path__ + "static/media/smilingWithPhone.2770f060.jpeg";